const sq = {
    "sc_title": "Qendra e Sigurisë",
    "sc_subtitle": "Shtresa e Sigurisë e Integruar GaiaShield",
    "sc_tab_status": "🛡️ Statusi i Mbrojtjes",
    "sc_tab_events": "📋 Regjistri i Sigurisë",
    "sc_tab_node": "⚙️ Siguria e Nyjes",
    "sc_loading": "Duke ngarkuar të dhënat e sigurisë...",
    "sc_status_secured": "Statusi i Sistemit: Llogaria është e mbrojtur",
    "sc_status_warning": "Statusi i Sistemit: Paralajmërime aktive",
    "sc_desc_secured": "Nuk ka paralajmërime kritike aktive për sigurinë. GaiaShield po monitoron në mënyrë aktive llogarinë tuaj.",
    "sc_desc_warning": "Kujdes: Ka ngjarje aktive të sigurisë që kërkojnë vëmendjen tuaj.",
    "sc_account_protection": "Mbrojtja e Llogarisë",
    "sc_message_protection": "Mbrojtja e Mesazheve",
    "sc_audits": "Auditime të Sigurisë",
    "sc_active": "AKTIV",
    "sc_failed_logins": "Hyrjet e Dështuara",
    "sc_tamper_checks": "Verifikimi i Ndërhyrjeve",
    "sc_blocked_replays": "Replay e Bllokuara",
    "sc_last_check": "Verifikimi i Fundit",
    "sc_just_now": "Tani tani",
    "sc_open_warnings": "Paralajmërime të Hapura",
    "sc_btn_acknowledge": "Konfirmo",
    "sc_filter_severity": "Shkalla e Rrezikut",
    "sc_filter_category": "Kategoria",
    "sc_filter_hide_ack": "Fshih të Konfirmuarat",
    "sc_btn_export": "Eksporto",
    "sc_col_details": "Detajet",
    "sc_col_time": "Koha",
    "sc_col_status": "Statusi",
    "sc_col_action": "Veprimi",
    "sc_no_events": "Nuk u gjet asnjë ngjarje sigurie.",
    "sc_node_title": "Konsola e Sigurisë e Operatorit të Nyjes",
    "sc_system_health": "Shëndeti i Sistemit",
    "sc_last_audit": "Auditi i Fundit",
    "sc_packed_logs": "Regjistrat e Paketuar",
    "sc_unconfirmed_events": "Ngjarje të Pakonfirmuara",
    "sc_operator_action": "Kërkohet Veprim nga Operatori",
    "sc_all_ok": "Gjithçka në Rregull",
    "sc_critical_events": "Ngjarje Kritike të Sistemit",
    "ac_title": "Qendra e Qeverisjes dhe Raportimit",
    "ac_subtitle": "Konsensusi i Qeverisjes dhe Abuzimit i GaiaCom",
    "ac_tab_my_reports": "Raportimet e Mia",
    "ac_tab_queue": "Radha e Rishikimit",
    "ac_tab_operator": "Operatori i Nyjes",
    "ac_tab_transparency": "Federata dhe Transparenca",
    "ac_loading": "Duke ngarkuar të dhënat...",
    "ac_reported_cases": "Rastet e Raportuara",
    "ac_no_reports": "Nuk keni dërguar ende asnjë raport.",
    "ac_case_details": "Detajet e Rastit",
    "ac_appeal_submit": "Dërgo Apelim",
    "ac_appeal_status": "Statusi i Apelimit",
    "ac_appeal_reason": "Arsyeja e Apelimit",
    "ac_appeal_statement": "Deklarata",
    "ac_btn_appeal": "Dërgo Apelimin",
    "ac_trusted_reviewer_queue": "Radha e Rishikuesit të Besuar",
    "ac_case_review": "Rishiko Rastin",
    "ac_review_category": "Kategoria e Rekomanduar",
    "ac_review_severity": "Shkalla e Rekomanduar e Rrezikut",
    "ac_review_action": "Veprimi i Rekomanduar",
    "ac_review_reason": "Arsyeja e Rishikuesit",
    "ac_btn_submit_review": "Dërgo Rishikimin",
    "ac_node_operator_dashboard": "Paneli i Operatorit të Nyjes",
    "ac_apply_action": "Zbato Veprimin (Mbishkruaj)",
    "ac_target_type": "Lloji i Shënjestrës",
    "ac_target_id": "ID e Shënjestrës (GaiaID ose ID e Kanalit)",
    "ac_suspend": "Pezullimi aktiv",
    "ac_reason": "Arsyeja Zyrtare",
    "ac_btn_apply": "Zbato Veprimin",
    "ac_transparency_title": "Libri i Konsensusi dhe Transparencës",
    "ac_transparency_desc": "Provat e snapshot-eve të shikueshme publikisht të të gjithë kanaleve dhe identiteteve të moderuara.",
    "ac_btn_snapshot": "Krijo Snapshot-in e Transparencës",
    "search_placeholder": "Kërko email sipas subjektit, dërguesit, tekstit...",
    "abuse_center_title": "Qendra e Abuzimit",
    "abbrechen": "Anulo",
    "active_identities": "Identitete aktive",
    "active_identity": "Identiteti aktiv",
    "add_btn": "Shto",
    "add_contact_title": "Shto kontakt",
    "admin": "Admin",
    "adressbuch": "drejtoria",
    "aktiviert": "Aktivizuar",
    "an": "te",
    "anonymous_sender": "Dërgues anonim",
    "antworten": "Përgjigju",
    "attachment_gaia_hint": "Bashkëngjitjet e GaiaCOM mbeten të koduara nga skaji në skaj.",
    "attachment_smtp_hint": "SMTP e trashëguar bllokon bashkëngjitjet e ekzekutueshme/si skripti dhe i ruan emailet si të pasigurta.",
    "attachments": "Shtojcat",
    "auffaellig": "E dukshme",
    "auth_beta_notice": "Faza e testimit beta: GaiaCOM po testohet në mënyrë aktive. Mund të ndodhin gabime; siguroni fara të rëndësishme dhe rishikoni me kujdes rrjedhat konfidenciale të punës.",
    "auth_btn_login": "Ngarko identitetin dhe identifikohu",
    "auth_btn_register": "Regjistrohu dhe krijo kripto",
    "auth_copied": "E kopjuar",
    "auth_copy_seed": "Kopjo farën",
    "auth_generate_seed": "Gjeneroni fara",
    "auth_headline": "GaiaCOM është protokolli i parë kuantik i postës elektronike dhe sistemi i komunikimit i ndërtuar për njerëzimin.",
    "auth_kicker": "Komunikimi i Sigurt pas Kuantik",
    "auth_mnemonic": "Fraza mnemonike",
    "auth_mnemonic_placeholder": "12 fjalë të ndara me hapësira...",
    "auth_password": "fjalëkalimin",
    "auth_password_placeholder": "••••••••••••••",
    "auth_proof_e2ee_desc": "Çelësat privatë nuk largohen nga pajisja juaj. Vetëm marrësit e synuar mund të deshifrojnë përmbajtjen.",
    "auth_proof_gaiadata_desc": "Zero-Njohuri: Ju mbeteni në kontroll të të dhënave tuaja. Metadatat minimizohen dhe nuk përdoren si profil teksti i thjeshtë.",
    "auth_proof_gaiadrop_desc": "Njerëzit e jashtëm mund të dërgojnë mesazhe teksti konfidenciale në GaiaID tuaj pa një llogari.",
    "auth_proof_gaiaproof_desc": "Dorëzimi dhe dëshmitë e integritetit tregojnë se teksti i koduar, dërguesi dhe vula kohore nuk janë ngacmuar.",
    "auth_proof_gaiavault_desc": "Shënimet private, shënimet e rikuperimit dhe të dhënat e sigurisë mbeten të koduara në nivel lokal.",
    "auth_proof_hybrid_desc": "Mburoja Quantum: Kriptimi hibrid me ML-KEM dhe X25519 mbron nga sulmet e sotme dhe nga rreziqet e depozituara tani-dekriptohen më vonë.",
    "auth_secure_mail": "Postë e sigurt e federuar kuantike",
    "auth_subline": "GaiaCOM është një sistem komunikimi kuantik i sigurt për email, chat, dhoma krize, GaiaDrop dhe skedarë lokalë të sigurisë. Çelësat privatë qëndrojnë në pajisjen tuaj, përmbajtja është e koduar nga skaji në skaj dhe provat mund të eksportohen pa tekst të thjeshtë.",
    "auth_success_btn": "Identifikohu tani",
    "auth_success_text": "Llogaria juaj GaiaCOM është krijuar. Çelësat janë marrë në nivel lokal nga fara juaj dhe nuk janë ruajtur në server.",
    "auth_success_title": "Regjistrimi i suksesshëm",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Hyrja/Llogaria",
    "auth_toggle_login": "Llogaria ekziston tashmë",
    "auth_toggle_register": "Krijo llogari të re",
    "auth_usecase_text": "I përshtatshëm për avokatë, kompani, autoritete, gazetarë, sinjalizues dhe çështje të sigurisë private.",
    "auth_usecase_title": "Ndërtuar për komunikim të ndjeshëm",
    "auth_username": "emri i përdoruesit",
    "auth_username_placeholder": "Fut emrin...",
    "auth_value_chat": "E2E Chat",
    "auth_value_drop": "Dorëzimi i sigurt",
    "auth_value_mail": "Postë e sigurt",
    "auth_value_rooms": "GaiaDhomat",
    "bestaetigen": "Konfirmo",
    "bestaetigt": "E konfirmuar",
    "bio_status": "Biografia/Statusi",
    "biography": "biografi",
    "change_password_desc": "Ndryshon fjalëkalimin tuaj të hyrjes nga ana e serverit. Fraza juaj e rikuperimit lokal mbetet e mbrojtur veçmas nga fjalëkalimi juaj i kasafortës/zhbllokimit.",
    "change_password_menu_desc": "Përditësoni fjalëkalimin e hyrjes në GaiaCOM.",
    "change_password_title": "Ndrysho fjalëkalimin",
    "channel_id": "ID e kanalit",
    "channel_name_label": "Emri i kanalit",
    "chat_deleted_hidden": "Biseda u fshi dhe u fsheh.",
    "chat_input_placeholder": "Fut një mesazh të sigurt...",
    "chat_start_hint": "Filloni bisedën! Të gjitha mesazhet e bisedës janë të koduara kuantike E2E.",
    "choose_avatar": "Zgjidhni avatarin",
    "ciphertext_hash": "Hash i tekstit të koduar",
    "clear_chat": "Bisedë bosh",
    "clear_for_everyone": "Bosh për të gjithë",
    "clear_for_me": "Bosh vetëm për mua",
    "click_to_write_mail": "Klikoni për të shkruar një email",
    "click_top_right": "Klikoni lart djathtas",
    "close": "Mbylle",
    "code_kopieren": "Kopjo kodin",
    "code_kopieren_success": "Kodi u kopjua",
    "confirm_clear_channel_desc": "Dëshiron ta fshish këtë kanal nga pamja jote lokale?",
    "confirm_clear_channel_title": "Kanali bosh",
    "confirm_clear_chat": "Dëshiron ta zbrazësh këtë bisedë?",
    "confirm_clear_chat_desc": "Dëshiron ta zbrazësh këtë bisedë?",
    "confirm_clear_chat_title": "Bisedë bosh",
    "confirm_clear_everyone": "Dëshiron të zbrazësh bisedën për të dy partnerët? (OK = Për të gjithë, Anulo = Vetëm për mua)",
    "confirm_delete_everyone": "Dëshiron të fshish mesazhin për të dy partnerët? (OK = Për të gjithë, Anulo = Vetëm për mua)",
    "confirm_delete_msg": "Dëshiron ta fshish këtë mesazh?",
    "confirm_delete_msg_desc": "Dëshiron ta fshish këtë mesazh bisede?",
    "confirm_delete_msg_title": "Fshi mesazhin",
    "confirm_new_password": "Konfirmo fjalëkalimin e ri",
    "copy": "Kopjo",
    "create_btn": "Krijo",
    "create_channel_title": "Krijo kanal",
    "create_group_is_crisis": "Shënoni si zonë krize",
    "create_group_title": "Krijo grup të ri",
    "crypto_lock_desc": "Kontrollon kur GaiaCOM heq çelësat lokalë të kriptove nga kujtesa.",
    "crypto_lock_menu_desc": "Kontrolloni kohëmatësit e ringarkimit dhe joaktivitetit.",
    "crypto_lock_title": "Kyçja kriptografike",
    "crypto_session_duration": "Zhbllokohet pas ringarkimit",
    "crypto_session_duration_desc": "Sesionin e kriptos e mban të hapur në këtë skedë të shfletuesit vetëm për kohëzgjatjen e zgjedhur.",
    "cryptographic_fingerprint": "Gjurmë gishtash kriptografike",
    "current_password": "Fjalëkalimi aktual",
    "data_minimization": "Minimizimi i të dhënave",
    "decrypt_failed": "E pa deshifrueshme",
    "delete": "Fshije",
    "delete_account_button": "Fshi llogarinë në mënyrë të pakthyeshme",
    "delete_account_confirm_label": "Futni DELETE për të konfirmuar",
    "delete_account_confirmation_error": "Kërkohet fjalëkalimi dhe konfirmimi DELETE.",
    "delete_account_desc": "Ky modalitet shkatërron përgjithmonë llogarinë tuaj, identitetet, seancat e pajisjes, të dhënat e GaiaDrop, të dhënat e ngarkimit dhe mesazhet që i atribuohen serverit.",
    "delete_account_done_desc": "Të gjitha të dhënat e GaiaCOM të caktueshme janë fshirë.",
    "delete_account_done_title": "Llogaria u fshi",
    "delete_account_menu_desc": "Shkatërroni llogarinë dhe të dhënat përkatëse.",
    "delete_account_not_authenticated": "Asnjë llogari aktive.",
    "delete_account_title": "Fshi llogarinë",
    "delete_for_everyone": "Fshije për të gjithë",
    "delete_for_me": "Fshije vetëm për mua",
    "device_current": "Kjo pajisje",
    "device_last_seen": "E fundit",
    "device_logout": "Dilni",
    "device_sessions_desc": "Kontrolloni sesionet aktive dhe çregjistroni pajisjet që nuk i besoni më.",
    "device_sessions_empty": "Nuk u gjet asnjë pajisje.",
    "device_sessions_menu_desc": "Menaxhoni dhe përfundoni seancat aktive.",
    "device_sessions_title": "Pajisjet e regjistruara",
    "device_since": "Që kur",
    "display_name": "Emri i shfaqur",
    "drop_address_copied": "Adresa e GaiaDrop u kopjua.",
    "drop_btn_decrypting": "Kutia hyrëse po deshifrohet...",
    "drop_btn_load": "Ngarko kutinë hyrëse të GaiaDrop",
    "drop_delete_desc": "Dëshiron vërtet ta fshish përgjithmonë këtë pikë?",
    "drop_delete_title": "Fshi GaiaDrop",
    "drop_desc": "Kanali i lëshimit të njohurive zero vetëm me tekst për njoftime të jashtme, zbulime të përgjegjshme dhe raporte konfidenciale. Palët e jashtme mund të dërgojnë mesazhe pa një llogari duke përdorur GaiaID tuaj.",
    "drop_empty": "Asnjë mesazh GaiaDrop nuk është ngarkuar ende.",
    "drop_id": "Hiq ID-në:",
    "drop_own_address": "Adresa juaj e GaiaDrop",
    "drop_proof": "DËSHMI DËSHIM",
    "drop_title": "Kutia hyrëse e sigurt e GaiaDrop",
    "dunkler_modus": "Modaliteti i errët",
    "e2e_chat_room_open": "Hapni dhomën e bisedës E2E",
    "edit_profile": "Redakto profilin",
    "edit_profile_desc": "Personalizo emrin e ekranit, biografinë dhe avatarin.",
    "einladungscode": "Kodi i ftesës",
    "enter_fingerprint_chars_confirm": "Futni karakteret e kërkuara të gjurmëve të gishtave për të konfirmuar.",
    "envelope_hash": "Zarfi hash",
    "erasability": "Fshirja",
    "erfolg": "Suksese",
    "exclude_plaintext": "Eksporto pa tekst të thjeshtë",
    "export_disclosure": "Rasti i sigurisë së eksportit",
    "export_package_desc": "Përfshini vetëm tekst të thjeshtë nëse ky zbulim synohet qëllimisht.",
    "export_package_title": "Eksporto paketën e sigurisë",
    "fehler": "Gabim",
    "gaiacom_reader": "GaiaCOM Reader",
    "gaiadrop_inbox_title": "GaiaDrop Inbox",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimizon metadatat, mban çelësat privatë lokalë, enkripton përmbajtjen nga fundi në fund dhe mundëson fshirjen e plotë të llogarisë.",
    "gdpr_home_title": "100% në përputhje me GDPR",
    "gdpr_reason_delete": "Fshirja e llogarisë heq llogarinë, identitetet, seancat lokale dhe të dhënat e caktueshme nga serveri.",
    "gdpr_reason_e2ee": "Përmbajtja private mbetet e deshifrueshme vetëm për marrësit e synuar.",
    "gdpr_reason_minimal": "Metadatat përdoren vetëm për kredencialet e rrugëzimit, dorëzimit dhe sigurisë.",
    "gdpr_reason_zero_knowledge": "Çelësat privatë dhe të dhënat e rikuperimit mbeten në nivel lokal nën kontrollin e përdoruesit.",
    "gesendet": "Dërguar",
    "gesperrt_verdaechtig": "E ndaluar / e dyshimtë",
    "group_delete_desc": "Dëshiron vërtet ta fshish këtë grup përgjithmonë? Të gjitha kanalet dhe mesazhet në këtë grup do të fshihen.",
    "group_delete_title": "Fshi grupin",
    "group_description": "Përshkrimi",
    "group_icon_label": "Ikona / avatari i grupit",
    "group_name": "Emri i grupit",
    "group_settings_avatar": "Avatari",
    "group_settings_desc": "Përshkrimi",
    "group_settings_is_crisis": "Shënoni si zonë krize",
    "group_settings_name": "Emri i grupit",
    "group_settings_title": "Cilësimet e grupit",
    "groups_empty_desc": "Krijoni një hapësirë ​​pune të sigurt për projekte, kriza ose komunikim ekipor.",
    "groups_empty_title": "Nuk ka ende biseda në grup",
    "gruppe_beitreten": "U bashkua me grupin",
    "gruppe_erstellen": "+ Krijo grup",
    "gruppe_verlassen": "Largohu nga grupi",
    "gruppen_chats": "Biseda në grup",
    "heller_modus": "Modaliteti i ndritshëm",
    "how_to_receive_drops": "Si mund të marr pika?",
    "identitaets_assistent": "Asistent Identiteti",
    "inactivity_lock_duration": "Kyç kur është joaktiv",
    "inactivity_lock_duration_desc": "Pas kësaj periudhe pa hyrje, GaiaCOM automatikisht do të bllokohet kriptografikisht.",
    "inactivity_lock_notice": "GaiaCOM është bllokuar kriptografikisht për shkak të pasivitetit.",
    "include_plaintext": "Përfshi tekst të thjeshtë",
    "invite_code_label": "Kodi i ftesës",
    "join_group_title": "Bashkohu në grup",
    "kanaele": "Kanalet",
    "kanal_erstellen": "+ kanal",
    "kein_chat_ausgewaehlt": "Asnjë bisedë e zgjedhur",
    "kein_kanal_ausgewaehlt": "Nuk është zgjedhur asnjë kanal",
    "keine_gruppe_ausgewaehlt": "Asnjë grup i zgjedhur",
    "keine_mails": "Nuk ka email të disponueshëm.",
    "key_change_warn_desc": "Çelësi publik i këtij kontakti ka ndryshuar. Kontrolloni gjurmën e gishtit përpara se t'i besoni.",
    "key_change_warn_title": "Paralajmërim kriptografik",
    "key_change_warning_changed": "ka ndryshuar. Kjo mund të jetë një shenjë e një sulmi njeri në mes!",
    "key_change_warning_msg": "Çelësi i identitetit për kontaktin",
    "key_transparency": "Transparenca kryesore",
    "kopiert": "E kopjuar",
    "kryptographische_schluessel": "Çelësat kriptografikë",
    "kryptographische_schluessel_desc": "Shfaq çelësat privatë dhe frazën e farës rezervë.",
    "laden": "Ngarko...",
    "leeren": "Bosh",
    "loading": "Ngarko...",
    "local_key_vault": "Kasaforta lokale e çelësave",
    "local_keys_label": "Çelësat lokalë",
    "lock_on_reload": "Gjithmonë kyçeni pas ringarkimit",
    "logout": "Dilni",
    "mail_compose": "Shkruani email",
    "mein_profil": "Profili im",
    "melden": "Raportoni",
    "menu": "menu",
    "message": "Lajme",
    "message_id": "ID e mesazhit",
    "message_pin": "Pin",
    "message_pinned_title": "Mesazhet e gozhduara",
    "message_react": "Reagoni",
    "message_reply": "Përgjigju",
    "message_replying_to": "Përgjigje për",
    "message_save": "Ruaj",
    "message_saved": "U ruajt",
    "message_to_channel": "Mesazh për",
    "message_unpin": "Zgjidheni",
    "message_unsave": "Mos kurseni",
    "mitglied": "Anëtar",
    "mitglieder": "anëtarët",
    "ml_kem": "ML-KEM",
    "neue_mail": "Email i ri",
    "never_auto_lock": "Asnjëherë automatikisht",
    "new_fingerprint": "Gjurmët e reja të gishtave",
    "new_identity": "Identiteti i ri",
    "new_password": "Fjalëkalim i ri",
    "no_description": "Asnjë përshkrim",
    "no_key_history": "Nuk është regjistruar asnjë histori kyçe.",
    "no_specification": "Nuk është specifikuar",
    "old_fingerprint": "Gjurmë gishtash të vjetër",
    "open_privacy_imprint": "Mbrojtja e printimit të hapur dhe e të dhënave",
    "post_quantum_e2e": "E2E post-kuantike",
    "posteingang": "Inbox",
    "powered_by": "Mundësuar nga",
    "privacy_imprint_menu_desc": "Trego GDPR, mbrojtjen e të dhënave dhe njoftimin ligjor.",
    "privacy_imprint_profile_desc": "GaiaCOM përpunon përmbajtjen e komunikimit sipas parimeve të minimizimit të të dhënave, enkriptimit nga fundi në fund dhe kontrollit lokal të çelësit.",
    "privacy_imprint_title": "Mbrojtja e të dhënave dhe njoftimi ligjor",
    "profil": "profili",
    "profile_details": "Detajet e profilit",
    "profile_settings_hint": "Cilësimet e profilit shfaqen në panelin e djathtë.",
    "profile_unlock_desc": "Për arsye sigurie, duhet të rifusni fjalëkalimin tuaj për të parë çelësat tuaj privatë kriptografikë.",
    "proof_hash": "Hash i provës:",
    "public_drop_desc": "Drop i sigurt për informacione të tekstit të jashtëm pa një llogari GaiaCOM.",
    "public_drop_message": "Lajme",
    "public_drop_message_placeholder": "Fut tekst konfidencial...",
    "public_drop_send": "Dërgo GaiaDrop",
    "public_drop_sender": "Shënimi i dërguesit është opsional",
    "public_drop_sender_placeholder": "Emri, numri i dosjes ose anonim",
    "public_drop_target": "Synoni GaiaID",
    "quanten_chat": "Bisedë Kuantike",
    "quantum_secure_exchange": "Shkëmbim kuantik i sigurt përmes...",
    "quantum_secure_net": "Rrjeti GaiaCOM Quantum Secure (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "Rrjeti GaiaCOM mbron privatësinë tuaj me një protokoll kriptimi hibrid me shumë shtresa, i cili mbrohet nga sulmet nga kompjuterët kuantikë të ardhshëm.",
    "quantum_shield_l1_desc": "Përdor standardin FIPS 203 për të përmbledhur një çelës të përbashkët simetrik. Parandalon regjistrimin pasiv dhe deshifrimin e mëvonshëm (\\\\\\",
    "quantum_shield_l1_title": "1. Mbrojtja pas kuantike (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Një procedurë klasike, jashtëzakonisht e shpejtë e shkëmbimit të çelësave Diffie-Hellman që shërben si një shtresë shtesë sigurie në procedurën hibride.",
    "quantum_shield_l2_title": "2. Kriptografia e kurbës eliptike (X25519)",
    "quantum_shield_l3_desc": "Çdo mesazh dhe çdo zarf i Federatës është i nënshkruar në mënyrë kriptografike për të verifikuar pa mëdyshje vërtetësinë e dërguesit.",
    "quantum_shield_l3_title": "3. Nënshkrimet dixhitale (Ed25519)",
    "quantum_shield_l4_desc": "Kripton përmbajtjen e mesazhit në mënyrë simetrike dhe lidh fort dërguesin, marrësin dhe meta të dhënat në të dhënat shtesë të vërtetuara (AAD) për të parandaluar sulmet e përsëritjes.",
    "quantum_shield_l4_title": "4. Vërtetimi AAD (AES-256-GCM)",
    "quantum_shield_status": "Statusi i Mburojës Kuantike",
    "receive_drops_step1": "Ndani GaiaID tuaj (p.sh. duke përdorur butonin e kopjimit më lart) me burime të jashtme.",
    "receive_drops_step2": "Këto thërrasin faqen e identifikimit të shembullit tuaj GaiaCOM dhe kaloni në skedën",
    "receive_drops_step3": "dhe dërgoni mesazhin e tyre të koduar në adresën tuaj.",
    "receiver_gaia": "Marrës GaiaCOM",
    "receiver_smtp": "Marrësi SMTP",
    "records_stored": "Regjistrimet u ruajtën",
    "refresh": "Përditëso",
    "report_abuse_desc": "Dëshiron ta raportosh këtë mesazh dhe të dorëzosh prova kriptografike të abuzimit në server?",
    "report_abuse_title": "Raportoni abuzimin",
    "reputation_status": "Statusi i reputacionit",
    "room_chat_start_hint": "Filloni bisedën! Të gjitha mesazhet në këtë kanal grupi janë të decentralizuara të sigurta kuantike E2E të koduara.",
    "room_policy_audit": "Gjurmët e auditimit dhe rrotullimi i çelësave janë aktiv.",
    "room_policy_crisis": "Dhoma e krizës",
    "room_policy_e2ee": "Hapësira e njohurive zero. E2EE e sigurt kuantike.",
    "room_policy_title": "Udhëzimet për dhomën",
    "room_policy_zero_knowledge": "Politika",
    "room_security_note_desc": "Të gjitha ndryshimet kryesore vërtetohen nëpërmjet Transparency Key. Përdorni GaiaVault për regjistrat e rezervimit privat.",
    "room_security_note_title": "Shënim sigurie i gozhduar",
    "save_profile": "Ruaj profilin",
    "schluessel_entsperrt": "🔑 Kyçeni përsëri çelësin",
    "search_gaia_label": "Gjeni adresën e Gaia",
    "security_warning_title": "Paralajmërim sigurie",
    "select_channel_chat": "Zgjidhni një kanal nga shiriti anësor i majtë për të biseduar.",
    "select_contact_chat": "Zgjidhni një kontakt nga paneli i majtë për të filluar një bisedë të sigurt kuantike E2E.",
    "select_mail_read": "Zgjidhni një email nga lista për të lexuar përmbajtjen e tij të sigurt kuantike ose për të krijuar një mesazh të ri.",
    "senden": "Dërgo",
    "sender_signature": "Nënshkrimi i dërguesit",
    "server_log": "Regjistri i serverit:",
    "server_received": "Serveri u pranua",
    "session_lock": "Bllokimi i seancës",
    "setup_address_keys": "Krijo adresën dhe grupin e çelësave",
    "setup_profile": "Vendosja në profil",
    "smtp_inbox_title": "Pritja SMTP",
    "smtp_legacy_badge": "SMTP e trashëguar / e pasigurt",
    "smtp_mode_option": "Ura e trashëgimisë SMTP",
    "smtp_security_warning": "Ky email u transmetua nëpërmjet protokollit klasik, të pakriptuar SMTP. Asnjë enkriptim nga fundi në fund nuk është aktiv.",
    "smtp_security_warning_desc": "Ky mesazh po largohet nga dhoma e sigurisë GaiaCom. Dorëzimi SMTP nuk ofron garanci origjinale të GaiaCom nga fundi në fund, asnjë garanci TrustMesh dhe asnjë garanci Godmode nga porta.",
    "spam_verdacht": "Spam/dyshim",
    "spam_warning_desc": "Ky mesazh ka sinjale të dyshimta reputacioni.",
    "spam_warning_title": "Paralajmërim për postë të padëshiruar",
    "speichern": "Ruaj",
    "sperren": "Mbylle jashtë",
    "standard_group_status": "Biseda standarde në grup (E2EE e koduar)",
    "status": "statusi",
    "subject": "Në lidhje me",
    "suchen": "Gjeni një adresë të re Gaia...",
    "tage": "ditë",
    "time_unknown": "Koha e panjohur",
    "transmission_mode": "Mënyra e transferimit",
    "trust_age": "Mosha e besimit",
    "trust_passport_title": "Pasaporta e Besimit",
    "unbestaetigt": "E pakonfirmuar",
    "unknown_sender": "E panjohur",
    "unlock_btn": "Zhblloko",
    "unlock_btn_profile": "Zhblloko",
    "unlock_desc": "Skedari juaj i çelësit privat ruhet i koduar. Futni fjalëkalimin tuaj për të ngarkuar vetëm çelësat kriptografikë në memorie.",
    "unlock_logout": "Dilni dhe mbyllni çelësat lokalë",
    "unlock_title": "Zhbllokoni identitetin",
    "untrusted": "Jo i besueshëm",
    "update_password": "Përditëso fjalëkalimin",
    "upload_avatar_btn": "Ngarko imazh (të dezinfektuar)",
    "vault_btn_encrypt": "Enkripto regjistrimin",
    "vault_btn_lock": "Mbylle kasafortën",
    "vault_btn_unlock": "Zhbllokoni kasafortën",
    "vault_copied_success": "Kopjuar në kujtesën e fragmenteve",
    "vault_decrypted_content": "Përmbajtje e deshifruar",
    "vault_desc": "Kasaforta e koduar lokale për kopje rezervë të rikuperimit, shënime identiteti, akses në server, kontakte emergjente, shënime ligjore, ngjarje sigurie dhe regjistra privatë.",
    "vault_empty": "Asnjë regjistrim i sigurt nuk është ruajtur ende.",
    "vault_locked_pane_notice": "Kasaforta është e kyçur. Ju lutemi, zhbllokoni në të djathtë.",
    "vault_new_record": "Rekord i ri i sigurt",
    "vault_pwd_placeholder": "Fut fjalëkalimin e Kasafortës...",
    "vault_record_body": "Regjistroni përmbajtjen",
    "vault_record_body_placeholder": "Fut përmbajtjen e regjistrimit të koduar...",
    "vault_record_category": "kategori",
    "vault_record_title": "Titulli i regjistrimit",
    "vault_record_title_placeholder": "Titulli i regjistrimit të sigurt",
    "vault_title": "GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "Kontrolloni gjurmën e re të gishtit përpara se të pranoni çelësin.",
    "vertrauenswuerdig": "I besueshëm",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "Nga",
    "warnung": "paralajmërim",
    "wizard_address": "adresa",
    "wizard_back": "Mbrapa",
    "wizard_check1": "Unë e kam ruajtur në mënyrë të sigurt farën time.",
    "wizard_custom_domain": "Përdorni domenin tuaj",
    "wizard_desc1": "GaiaCOM nuk ruan çelësat privatë në anën e serverit. Pa Mnemonic Seed, askush nuk mund të rikuperojë mesazhet e humbura.",
    "wizard_desc2": "Adresa juaj përcakton nyjen e federuar përmes së cilës drejtohen zarfet e koduar.",
    "wizard_fallback": "Nyjet e kthimit",
    "wizard_finish": "Konfigurimi i plotë",
    "wizard_next": "Më tej",
    "wizard_server_domain": "Domeni i nyjës së serverit",
    "wizard_step1": "1. Backup Seed",
    "wizard_step2": "2. Adresa & Serveri",
    "wizard_title1": "Rezervo çelësin e rikuperimit",
    "wizard_title2": "Zgjidhni adresën GaiaCOM",
    "write_message_placeholder": "Shkruani një mesazh të sigurt...",
    "you": "Ju",
    "zero_knowledge": "Njohuri zero",
    "zero_knowledge_encryption": "Kriptimi me njohuri zero",
    "Chat fuer alle geleert": "Biseda është zbrazur për të gjithë pjesëmarrësit.",
    "Chat geleert": "Biseda është pastruar për kutinë tuaj hyrëse lokale.",
    "Nachricht fuer alle geloescht": "Mesazhi është fshirë për të gjithë pjesëmarrësit.",
    "Nachricht geloescht": "Mesazhi i bisedës është hequr lokalisht nga kutia juaj hyrëse.",
    "anpinnen": "Pin",
    "chat_loeschen": "Fshi bisedën",
    "confirm_delete_chat_desc": "Jeni i sigurt që dëshironi të fshini dhe fshehni bisedën?",
    "confirm_leave_group_desc": "Dëshiron vërtet të largohesh nga ky grup?",
    "entpinnen": "Zhgozhdoni",
    "group_deleted": "Grupi u fshi me sukses.",
    "group_left": "Largohu me sukses nga grupi.",
    "gruppe_loeschen": "Fshi grupin",
    "loeschen": "Fshije",
    "no_active_chats": "Nuk ka biseda aktive. Kërkoni kontaktet e mësipërme për të filluar një bisedë.",
    "pinned": "E ngulitur",
    "wizard_check_credentials": "Unë jam përgjegjës për ruajtjen e të dhënave të mia të aksesit të sigurta.",
    "wizard_check_is_beta": "Unë e kuptoj që GaiaCom është softuer beta.",
    "wizard_check_no_illegal": "Nuk do ta përdor GaiaCom për qëllime të paligjshme.",
    "wizard_check_no_uptime": "Unë e kuptoj që nuk ka asnjë garanci për disponueshmërinë.",
    "wizard_check_smtp_security": "Unë e kuptoj që mesazhet SMTP nuk ofrojnë siguri të plotë të GaiaCom.",
    "wizard_check_terms_read": "Kam lexuar Kushtet e Shërbimit Beta.",
    "wizard_step_terms": "Kushtet e Përdorimit",
    "wizard_terms_text": "Kushtet e përdorimit të GaiaCom dhe Marrëveshja e testimit beta (faza beta)\n\nOfruesi: VisionGaiaTechnology (në tekstin e mëtejmë \"Ofruesi\")\nStatusi: Faza e testimit beta publike\nVlefshmëria: Nga 21 qershor 2026\n\n⚠️ SHËNIM MË I RËNDËSISHËM PARAPARA (JU LUTEM LEXOJENI ME KUJDES)\nGaiaCom është në një fazë testimi publik beta. Pavarësisht masave të gjera të sigurisë, liria nga gabimet, disponueshmëria e vazhdueshme ose siguria absolute e softuerit dhe infrastrukturës bazë nuk mund të garantohet. Përdoreni në rrezikun tuaj. Përdoruesit janë përgjegjës për ruajtjen e sigurt të të dhënave të tyre të aksesit (veçanërisht çelësat për GaiaVault) dhe për pajtueshmërinë me ligjet në fuqi.\n\n1. Subjekti dhe qëllimi i fazës së testit beta\n1.1. Qëllimi i ofrimit: GaiaCom është një shërbim i ri për email dhe bisedë i bazuar në kriptografinë post-kuantike (PQC). Dispozita gjatë fazës beta ka për qëllim ekskluzivisht testimin teknik, simulimin e ngarkesës, gjetjen e gabimeve të programit (bugs) dhe optimizimin e përshtatshmërisë ndaj përdoruesit.\n1.2. Statusi beta: Përdoruesi është i vetëdijshëm se softueri i ofruar është një version paraprak (softuer beta). Ky nuk është ende plotësisht i zhvilluar teknikisht, nuk plotëson standardin e një produkti përfundimtar, komercial dhe mund të shkaktojë gabime, humbje të të dhënave, vonesa të transmetimit ose prishje të sistemit.\n1.3. Nuk ka të drejtë për vazhdim: Ofruesi ka të drejtë në çdo kohë të ndërpresë shërbimin tërësisht ose pjesërisht, të ndryshojë ose kufizojë funksionet ose t'i heqë ato përkohësisht ose përgjithmonë pa dhënë arsye.\n\n2. Disponueshmëria dhe mohimi i garancisë\n2.1. Asnjë garanci disponueshmërie: GaiaCom ofrohet pa asnjë garanci për disponueshmërinë ose kohën e funksionimit. Nuk ka të drejtë për disponueshmëri të pandërprerë të shërbimit.\n2.2. Përjashtimi i garancisë: Softueri ofrohet në gjendjen e tij aktuale (“siç është”) dhe i nënshtrohet disponueshmërisë. Për aq sa lejohet me ligj, çdo pretendim garancie për defekte materiale dhe ligjore në softuer përjashtohet. Në veçanti, nuk ka asnjë garanci që softueri është pa gabime, pa malware ose i përshtatshëm për një qëllim të caktuar.\n\n3. Menaxhimi i riskut dhe detyrimet e përdoruesve\n3.1. Ndalimi i ruajtjes së të dhënave kritike: Përdoruesi merr përsipër të mos ruajë ose transmetojë ekskluzivisht përmes GaiaCom asnjë të dhënë kritike biznesi, jetike, operacionale ose veçanërisht të ndjeshme ligjërisht (si skedarët e pacientëve, të dhënat financiare shumë të ndjeshme ose sekretet e rregulluara zyrtarisht). Shërbimi nuk mund të përdoret për infrastrukturë ku dështimet e paparashikuara mund të rezultojnë në dëmtim personal, dëmtim të pronës ose humbje të konsiderueshme financiare.\n3.2. Rezervimi i vetëpërgjegjshëm: Përdoruesi është përgjegjës për rezervimin e të gjitha të dhënave të marra ose të dërguara nëpërmjet GaiaCom që i nevojiten për një kohë të gjatë në sistemet e tij të pavarura (kopje rezervë). Ofruesi nuk garanton ruajtjen ose rikthimin e përhershëm të të dhënave në serverët e tij.\n\n4. Karakteristikat kriptografike dhe GaiaVault\n4.1. Kriptografia post-kuantike (PQC): GaiaCom zbaton procese kriptimi të orientuara drejt së ardhmes, të cilat janë të dizajnuara për t'i bërë ballë sulmeve nga kompjuterët kuantikë të ardhshëm. Megjithatë, përdoruesi është i vetëdijshëm se kjo është një fushë shkencore dinamike dhe e re. Siguria absolute dhe e pakundërshtueshme nuk mund të garantohet bazuar në gjendjen aktuale të shkencës dhe teknologjisë. Terma të tillë si \"100% i sigurt\", \"i pathyeshëm\" ose \"i sigurt ushtarak\" nuk garantohen shprehimisht.\n4.2. Asnjë garanci rikuperimi (GaiaVault): GaiaCom mbështetet në një koncept të qëndrueshëm sigurie me njohuri zero. Pykat e kriptimit dhe të dhënat e aksesit mbeten vetëm në kontrollin e përdoruesit (të siguruara nëpërmjet GaiaVault).\nE RËNDËSISHME: Nëse përdoruesi humbet fjalëkalimet, frazat e kalimit, çelësat privatë ose farat e rikuperimit, ofruesi nuk ka aftësi teknike për të rindërtuar ose rivendosur këto të dhëna. Humbja e këtyre të dhënave të aksesit çon në mënyrë të pashmangshme në humbjen e pakthyeshme të aksesit në llogarinë e përdoruesit dhe të gjitha të dhënat e koduara në të.\n4.3. Ende i pa audituar plotësisht: Softueri i nënshtrohet vazhdimisht kontrolleve të brendshme të sigurisë, por në kohën e kësaj faze beta nuk i është nënshtruar ende një auditimi përfundimtar, gjithëpërfshirës të sigurisë së jashtme nga organe të pavarura testimi.\n\n5. Ndërfaqet, protokollet e trashëgimisë dhe federata\n5.1. SMTP Bridge Shënim: GaiaCom ofron mundësinë për të komunikuar nëpërmjet protokolleve klasike të postës elektronike (si p.sh. SMTP). Përdoruesi është i vetëdijshëm se mesazhet që largohen nga zona e sigurisë së GaiaCom (p.sh. kur dërgohen në një adresë konvencionale @gmail.com ose @gmx.de) transportohen nëpërmjet serverëve të pa enkriptuar ose të palëve të treta. Garancitë e sigurisë nga fundi në fund të GaiaCom zbatohen vetëm në një masë të kufizuar ose aspak për mesazhe të tilla të vjetra dalëse ose hyrëse.\n5.2. Shënim i Federatës: Nëse GaiaCom operon në një rrjet të federuar, mesazhet dhe të dhënat mund të kalojnë përmes serverëve të palëve të treta. Ndërsa përmbajtja e mesazheve mbetet e mbrojtur nga kriptimi nga skaji në fund, meta të dhënat (siç është koha e dërgimit, adresat IP të serverëve të përfshirë dhe adresat e marrësve) mund të jenë teknikisht të dukshme për operatorët e këtyre serverëve të federuar. Ofruesi nuk ka asnjë ndikim në praktikat e mbrojtjes së të dhënave të operatorëve të serverëve të palëve të treta në rrjetin e federuar.\n\n6. Përdorime të pranueshme dhe aktivitete të ndaluara\nPërdoruesi merr përsipër të mos e përdorë shërbimin në mënyrë të pahijshme ose për qëllime të paligjshme. Në veçanti, të mëposhtmet janë të ndaluara:\n- Shpërndarja, dërgimi ose mbajtja e viruseve, malware, përmbajtjeve të phishing ose programeve të tjera me qëllim të keq.\n- Përdorimi i Shërbimit për të kryer sulme të mohimit të shërbimit (DDoS) ose postime të pakërkuara me shumicë (spam).\n- Abuzimi i sistemit për të kryer mashtrime.\n- Shpërndarja ose shkëmbimi i përmbajtjes ilegale, në veçanti përshkrimet e abuzimit seksual të fëmijëve (CSAM), propaganda terroriste, thirrjet për dhunë ose përmbajtje të tjera të rëndësishme kriminale.\n\n7. Sistemi i raportimit të abuzimeve\n7.1. Raportimi i sjelljes abuzive: Përdoruesit kanë mundësinë të raportojnë komunikime abuzive ose aktivitete të paligjshme nëpërmjet sistemit të integruar të abuzimit.\n7.2. Përpunimi i raporteve: Për të siguruar mbrojtje nga keqpërdorimi, raportet hyrëse mund të analizohen teknikisht (duke ruajtur kufizimet e privatësisë dhe të enkriptimit). Kjo mund të çojë në pezullim të përkohshëm ose të përhershëm të llogarive të përdoruesve ose adresave IP në rast të shkeljeve të vërtetuara të këtyre kushteve të përdorimit.\n\n8. Kufizimi i përgjegjësisë\n8.1. Standardi i përgjegjësisë: Softueri beta ofrohet pa pagesë. Sipas rregullave ligjore për donacionet ose huatë, ofruesi është për këtë arsye përgjegjës vetëm për qëllim (dëm të qëllimshëm) dhe pakujdesi të rëndë.\n8.2. Përjashtimi i përgjegjësisë për humbjen e të dhënave: Përgjegjësia për humbjen e të dhënave përjashtohet nëse humbja është shkaktuar me dashje ose nga neglizhenca e rëndë nga ofruesi dhe përdoruesi ka përmbushur detyrimin e tij për të zbutur dëmin përmes kopjeve rezervë të rregullt (jashtë GaiaCom).\n8.3. Kufijtë ligjorë: Kufizimet e mësipërme të përgjegjësisë nuk zbatohen për dëmtimin e jetës, trupit ose shëndetit ose për përgjegjësinë sipas Ligjit për Përgjegjësinë e Produkteve.\n\n9. Burim i hapur\nDisa komponentë, biblioteka ose aplikacione klienti të GaiaCom mund të licencohen me licenca me burim të hapur (p.sh. GPL, MIT, Apache). Kushtet përkatëse të licencës të këtyre komponentëve mbeten të paprekura nga këto kushte përdorimi dhe mund të shikohen në depot përkatëse të kodit burimor.\n\n10. Kontrolli dhe Pajtueshmëria e Eksportit\nPërdoruesi është i vetëdijshëm se softueri kriptografik mund t'i nënshtrohet kontrolleve të rrepta të eksportit dhe kufizimeve ligjore. Përdoruesi është përgjegjës për të siguruar që përdorimi i GaiaCom nuk shkel ligjet, kufizimet e importit/eksportit ose rregulloret e kriptografisë të vendit të tyre përkatës të banimit.\n\n11. Njoftim për mbrojtjen e të dhënave (versioni i shkurtër për beta)\n11.1. Mbledhja minimale e të dhënave: Si pjesë e fazës beta, ofruesi mbledh vetëm të dhëna që janë absolutisht të nevojshme për funksionimin teknik, zgjidhjen e problemeve dhe zhvillimin e mëtejshëm (p.sh. skedarët e regjistrit të serverit për diagnostikimin e gabimeve).\n11.2. Nuk ka njohuri për përmbajtjen: Falë njohurive të qëndrueshme zero dhe enkriptimit E2E, ofruesi nuk ka kurrë qasje në përmbajtjen e bisedave, emaileve ose çelësave tuaj të ruajtur në GaiaVault.\n11.3. Deklarata e detajuar e mbrojtjes së të dhënave: Rregulloret e detajuara të mbrojtjes së të dhënave janë të lidhura veçmas dhe duhet gjithashtu të merren parasysh nga përdoruesi përpara se të regjistrohet.\n\n12. Dispozitat përfundimtare\n12.1. Ligji në fuqi: Zbatohet ligji i Republikës Federale të Gjermanisë, duke përjashtuar Konventën e OKB-së për Kontratat për Shitjen Ndërkombëtare të Mallrave.\n12.2. Subjekt për ndryshim: Meqenëse GaiaCom është në zhvillim aktiv, ofruesi rezervon të drejtën t'i përshtatë këto kushte në çdo kohë me efekt për të ardhmen. Versioni aktual është i disponueshëm në aplikacion.",
    "wizard_terms_title": "Kushtet e përdorimit të GaiaCom dhe Marrëveshja e testimit beta (faza beta)",
    "node_operator": "Operatori i nyjës",
    "search_channels": "Kërko kanale...",
    "senior_reviewer": "Recensues i lartë",
    "trusted_reviewer": "Rishikues i besuar",
    "active_frequencies": "Frekuenca aktive",
    "connected_rooms": "HAPËSIRAT E LIDHUR",
    "dashboard": "Paneli",
    "empty_chats": "Nuk disponohen biseda aktive.",
    "empty_messages": "Nuk ka mesazhe të reja në dispozicion.",
    "encrypted": "E koduar",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Instaloni aplikacionin",
    "install_app_desc": "Për fillimin e shpejtë dhe modalitetin offline",
    "kommandozentrale_alpha": "Qendra komanduese ALPHA",
    "network_online": "RRJETI: ONLINE",
    "new_room": "Hapësirë ​​e re",
    "no_frequencies_active": "Nuk ka frekuenca aktive. Krijo një dhomë të re për të filluar komunikimin.",
    "no_id": "Nuk ka ID",
    "open_chats": "Hapni bisedat",
    "open_inbox": "Hap kutinë hyrëse",
    "primary_identity": "IDENTITET PRIMAR",
    "recent_chats": "Biseda të reja",
    "recent_messages": "Lajmet e fundit",
    "session_encrypted": "Sesioni i koduar: {name}",
    "session_secure": "STATUSI: I SIGURT",
    "system_verlassen": "Sistemi i daljes",
    "write_message": "Shkruani një mesazh",
    "archiv": "Arkivi",
    "entwuerfe": "Draftet",
    "markiert": "Me yll",
    "wichtig": "Të rëndësishme",
    "snoozed": "Shtyrë",
    "papierkorb": "Koshi",
    "spam": "Spam",
    "cancel": "Anulo",
    "error": "Gabim",
    "success": "Sukses",
    "kopieren": "Kopjo",
    "block_contact": "Blloko kontaktin",
    "unblock_contact": "Zhblloko kontaktin",
    "report_contact": "Raporto kontaktin",
    "check_fingerprint": "Verifiko gjurmën",
    "export_encrypted": "Eksporto (Kriptuar)",
    "export_gaiaproof": "Eksporto (GaiaProof)",
    "export_password_prompt": "Ju lutemi vendosni një fjalëkalim për të kriptuar eksportin e bisedës:",
    "export_success": "Biseda u eksportua dhe u kriptua me sukses.",
    "export_failed": "Eksporti dështoi: ",
    "gaiaproof_export_success": "Paketa GaiaProof u eksportua me sukses.",
    "gaiaproof_export_failed": "Eksporti i GaiaProof dështoi: ",
    "export_gaiaproof_confirm": "A dëshironi të shkarkoni paketën GaiaProof me të gjitha nënshkrimet dhe vërtetimet e dorëzimit të serverit? Kjo mund të marrë pak kohë.",
    "group_settings_is_private": "Dhomë private (jo e kërkueshme publikisht, vetëm me kërkesa për t'u bashkuar)",
    "group_settings_read_only": "Modaliteti vetëm-lexim (vetëm pronari dhe administratorët mund të dërgojnë mesazhe)",
    "group_settings_slow_mode": "Modaliteti i ngadaltë (cooldown i dërgimit)",
    "gsn_title": "GSN Social Feed",
    "gsn_node_feed": "Node Feed",
    "gsn_following_feed": "Duke ndjekur",
    "gsn_feed_empty": "Nuk u gjet asnjë postim.",
    "gsn_composer_placeholder": "Çfarë ka të re në federatë?",
    "gsn_post_btn": "Shpërndaj",
    "gsn_profile": "Profili i përdoruesit",
    "gsn_followers": "Ndjekësit",
    "gsn_following": "Duke ndjekur",
    "gsn_bio": "Përshkrimi / Bio:",
    "gsn_bio_label": "Përshkrimi / Bio",
    "gsn_display_name": "Emri i shfaqjes",
    "gsn_edit_profile": "Ndrysho profilin",
    "gsn_save_profile": "Ruaj",
    "gsn_add_image": "Shto imazh (Kriptuar)",
    "gsn_add_emoji": "Shto emoji",
    "gsn_avatar_emoji": "Avatari (Emoji)",
    "gsn_follow": "Ndiq",
    "gsn_unfollow": "Mos ndiq",
    "gsn_repost": "Shpërndaj / Reposto",
    "gsn_post_created": "Postimi u shpërnda me sukses.",
    "gsn_image_uploaded": "Imazhi u kriptua dhe u ngarkua.",
    "gsn_upload_failed": "Ngarkimi i imazhit dështoi: ",
    "gsn_comment_placeholder": "Shkruani një koment...",
    "gsn_delete_confirm_title": "Fshi postimin?",
    "gsn_delete_confirm_desc": "A jeni i sigurt që dëshironi të fshini përgjithmonë këtë postim?",
    "gsn_delete_comment_confirm_title": "Fshi komentun?",
    "gsn_delete_comment_confirm_desc": "A jeni i sigurt që dëshironi të fshini përgjithmonë këtë koment?",
    "gsn_report": "Raporto",
    "gsn_report_title": "Raporto shkeljen",
    "gsn_report_category": "Kategoria",
    "gsn_report_spam": "Spam / Reklamë",
    "gsn_report_harassment": "Ngacmim / Gjuhë urrejtjeje",
    "gsn_report_abuse": "Abuzim",
    "gsn_report_illegal": "Përmbajtje ilegale",
    "gsn_report_severity": "Dringshmëria",
    "gsn_report_low": "Ulët",
    "gsn_report_medium": "Mesatare",
    "gsn_report_high": "Lartë",
    "gsn_report_comment": "Koment shtesë",
    "gsn_report_submit": "Raporto",
    "gsn_report_submitted": "Raporti u dërgua te qeverisja.",
    "gsn_report_post": "Raporto postimin",
    "report_group": "Raporto grupin",
    "report_group_reason_prompt": "Ju lutemi vendosni një arsye për raportimin (opsionale):",
    "report_reason_prompt": "Ju lutemi vendosni një arsye për raportimin (opsionale):",
    "report_failed": "Raportimi dështoi: ",
    "report_success": "Kontakti u raportua me sukses.",
    "room_read_only_placeholder": "Vetëm pronari dhe administratorët mund të shkruajnë",
    "read_only_active": "Modaliteti vetëm-lexim",
    "slow_mode_active": "Modaliteti i ngadaltë aktiv",
    "kommandozentrale": "Qendra e komandës",
    "kontakt_blockiert": "Kontakti u bllokua",
    "kontakt_freigegeben": "Kontakti u zhbllokua",
    "mailbox_settings_title": "Cilësimet e kutisë së postës",
    "mailbox_settings_desc": "Menaxho nënshkrimin, gjuhën, filtrat e postës.",
    "mic_access_denied": "Aksesi në mikrofon u refuzua: ",
    "no_frequencies_active_desc": "Krijoni një dhomë të re për të filluar komunikimin.",
    "key_changed_warning_title": "NJOFTIM SIGURIE:",
    "key_changed_warning_desc": "Çelësi i identitetit të këtij dërguesi është përditësuar ose ndryshon nga ai i njohur më parë. Ju lutemi verifikoni gjurmën përmes një kanali tjetër të sigurt.",
    "sc_col_category": "Kategoria",
    "search_members": "Kërko anëtarë...",
    "tab_general": "Përgjithshme",
    "tab_members": "Anëtarët",
    "tab_requests": "Kërkesat",
    "tab_invites": "Ftesat",
    "tab_logs": "Protokollet",
    "auth_why_gaiacom": "Pse GaiaCOM?",
    "auth_why_gaiacom_desc": "Alternativa e sigurt dhe e decentralizuar për komunikimin tuaj konfidencial.",
    "auth_self_managed_id": "ID e vetë-menaxhuar",
    "auth_self_managed_id_desc": "Krijoni menjëherë identitete të sigurta kriptografike pa dhënë email ose numër telefoni.",
    "auth_gaiadrop_secure_exchange": "Këmbim i sigurt pa llogari",
    "auth_gaiadrop_benefit_e2ee": "Kriptuar nga fundi në fund",
    "auth_gaiadrop_benefit_no_login": "Nuk kërkohet hyrje",
    "auth_gaiadrop_benefit_inbox": "Dorëzimi direkt në kutinë e postës së marrësit",
    "auth_terms_of_use": "Kushtet e përdorimit",
    "auth_terms_of_use_show": "Shfaq kushtet e përdorimit",
    "auth_consent_privacy_terms": "Kam lexuar dhe pajtohem me politikat e privatësisë dhe kushtet e përdorimit.",
    "auth_recovery_mode": "Modaliteti i rikuperimit",
    "auth_recovery_import_file": "Rikthe skedarin e rikuperimit",
    "auth_recovery_import_desc": "Rikthe çelësat tuaj të GaiaCom nga një skedar rezervë i mbrojtur me fjalëkalim. Pas kësaj, mnemonic dhe emri i përdoruesit plotësohen paraprakisht.",
    "auth_recovery_password": "Fjalëkalimi i skedarit të rikuperimit",
    "auth_recovery_local_password": "Fjalëkalimi i ri lokal i zhbllokimit min. 12 karaktere",
    "auth_recovery_decrypting": "Duke deshifruar rikuperimin...",
    "auth_recovery_back": "Kthehu tek hyrja",
    "auth_cookie_sovereign": "GaiaCOM mbetet sovran.",
    "auth_cookie_sovereign_desc": "Ne përdorim vetëm funksionet e nevojshme teknike të ruajtjes lokale për gjuhën, sesionin dhe sigurinë. Pa gjurmim, pa cookie reklamash, pa profile të palëve të treta.",
    "auth_cookie_sovereign_accept": "E kuptova",
    "unlock_keyboard_toggle": "⌨️ Përdor tastierën",
    "unlock_keypad_toggle": "🔢 Përdor PIN-padin",
    "unlock_status_denied": "AKSESI U REFUZUA / PROVO PËRSËRI",
    "unlock_status_decrypting": "DUKE DESHIFRUAR KASAFORTËN...",
    "unlock_status_secured": "KASAFORTA E SIGURUAR / E MBYLLUR",
    "auth_back_to_login": "Kthehu tek hyrja",
    "auth_cookie_accept": "E kuptova",
    "auth_cookie_desc": "Ne përdorim vetëm funksionet e nevojshme teknike të ruajtjes lokale për gjuhën, sesionin dhe sigurinë. Pa gjurmim, pa cookie reklamash, pa profile të palëve të treta.",
    "auth_cookie_title": "GaiaCOM mbetet sovran.",
    "auth_legal_consent": "Kam lexuar dhe pajtohem me politikat e privatësisë dhe kushtet e përdorimit.",
    "auth_recovery_decrypt": "Deshifro rikuperimin",
    "auth_recovery_file_pwd_placeholder": "Fjalëkalimi i skedarit të rikuperimit",
    "auth_recovery_import_title": "Rikthe skedarin e rikuperimit",
    "auth_recovery_importing": "Duke importuar...",
    "auth_recovery_local_pwd_placeholder": "Fjalëkalimi i ri lokal i zhbllokimit min. 12 karaktere",
    "auth_show_terms": "Shfaq kushtet e përdorimit",
    "auth_terms_close": "Mbyll",
    "auth_terms_title": "Kushtet e përdorimit të GaiaCom Beta",
    "onboarding_back": "Mbrapa",
    "onboarding_backup_consent": "Unë e kam ruajtur farën time të rikuperimit në mënyrë të sigurt.",
    "onboarding_backup_desc": "Fara juaj e rikuperimit është i vetmi çelës për të rikthyer llogarinë tuaj. Shkruajeni atë në letër dhe ruajeni në një vend të sigurt.",
    "onboarding_backup_notice_desc": "Ofruesi nuk ruaj çelësat tuaj në server. Nëse humbni farën tuaj, të dhënat tuaja do të humbasin përgjithmonë.",
    "onboarding_backup_notice_title": "Shënim i rëndësishëm i sigurisë",
    "onboarding_backup_title": "Rezervo çelësin e rikuperimit",
    "onboarding_channels_desc": "Krijoni kanale publike për të publikuar njoftime të nënshkruara në mënyrë kriptografike.",
    "onboarding_channels_title": "Kanale publike",
    "onboarding_complete_setup": "Përfundo konfigurimin",
    "onboarding_contacts_desc": "Shtoni kontakte përmes GaiaID për të filluar biseda të sigurta.",
    "onboarding_contacts_title": "Menaxhimi i kontakteve",
    "onboarding_continue": "Vazhdo",
    "onboarding_display_name": "Emri i shfaqjes",
    "onboarding_display_name_placeholder": "Shkruani emrin tuaj...",
    "onboarding_inbox_desc": "Kutia juaj hyrëse mbron të gjitha mesazhet tuaja me enkriptim post-kuantik.",
    "onboarding_inbox_title": "Kutia e sigurt e mesazheve",
    "onboarding_later": "Më vonë",
    "onboarding_launch_desc": "Llogaria juaj është gati. Mirë se vini në rrjetin e sigurt të komunikimit GaiaCOM.",
    "onboarding_launch_title": "Gati për të filluar",
    "onboarding_loading_gaia_id": "Duke ngarkuar GaiaID...",
    "onboarding_profile_desc": "Vendosni profilin tuaj me një emër shfaqjeje dhe avatar.",
    "onboarding_profile_title": "Profili i përdoruesit",
    "onboarding_sec_identity_desc": "Identiteti juaj mbrohet nga çelësa kriptografikë lokalë që nuk dërgohen kurrë në server.",
    "onboarding_sec_identity_title": "Identiteti Sovran",
    "onboarding_sec_messages_desc": "Çdo mesazh enkriptohet nga fundi në fund me algoritme post-kuantike.",
    "onboarding_sec_messages_title": "Enkriptimi E2EE",
    "onboarding_sec_network_desc": "Rrjeti i federuar siguron që asnjë pikë e vetme dështimi të mos rrezikojë komunikimin tuaj.",
    "onboarding_sec_network_title": "Rrjeti i federuar",
    "onboarding_sec_transparency_desc": "Proceset e konsensusit dhe auditimit mundësojnë verifikimin e plotë të integritetit të mesazheve.",
    "onboarding_sec_transparency_title": "Transparenca Kriptografike",
    "onboarding_security_desc": "Mbrojtja juaj bazohet në shtresa të avancuara të sigurisë post-kuantike.",
    "onboarding_security_desc_card": "GaiaShield monitoron në mënyrë aktive manipulimet dhe sulmet e mundshme.",
    "onboarding_security_title": "Shtresat e Sigurisë",
    "onboarding_security_title_card": "Mbrojtja aktive",
    "onboarding_select_avatar": "Zgjidhni një avatar",
    "onboarding_setup_kicker": "Konfigurimi i parë",
    "onboarding_step_backup": "Rezervimi",
    "onboarding_step_launch": "Fillimi",
    "onboarding_step_profile": "Profili",
    "onboarding_step_security": "Siguria",
    "sc_explainer_desc": "GaiaShield integron disa shtresa të sigurisë post-kuantike për të mbrojtur identitetin dhe komunikimet tuaja.",
    "sc_explainer_identity_desc": "Çelësat tuaj privatë ruhen vetëm në pajisjen tuaj dhe nuk ndahen kurrë.",
    "sc_explainer_messages_desc": "Mesazhet tuaja janë të mbrojtura nga enkriptimi ML-KEM nga fundi në fund.",
    "sc_explainer_network_desc": "Federata e serverëve GaiaCOM parandalon kontrollin e centralizuar të të dhënave.",
    "sc_explainer_title": "Si funksionon GaiaShield?",
    "sc_login_attacks": "Sulmet e identifikuara",
    "sc_no_entries": "Nuk ka regjistrime në protokoll.",
    "sc_no_node_events": "Nuk ka ngjarje të raportuara nga nyja.",
    "sc_node_audit_log": "Protokolli i auditimit të nyjës",
    "sc_node_security_data_unavailable": "Të dhënat e sigurisë së nyjës nuk janë të disponueshme.",
    "sc_open_security_warnings": "Paralajmërime aktive të sigurisë",
    "sc_opt_all": "Të gjitha",
    "sc_opt_auth_attack": "Sulm vërtetimi",
    "sc_opt_critical": "Kritike",
    "sc_opt_failed_login": "Hyrje e dështuar",
    "sc_opt_high": "Lartë",
    "sc_opt_low": "Ulët",
    "sc_opt_medium": "Mesatare",
    "sc_opt_message_replay": "Përsëritje mesazhi",
    "sc_opt_policy_violation": "Shkelje politike",
    "sc_opt_rate_limit": "Limit i shpejtësisë",
    "sc_rate_limits_active": "Limitet e shpejtësisë aktive",
    "sc_smtp_shield_hits": "Bllokime të SMTP Shield",
    "sc_top_event_categories": "Kategoritë kryesore të ngjarjeve",
    "sc_total_events": "Ngjarjet totale",
    "auth_landing_nav_legal": "Ligjore",
    "auth_landing_nav_beta": "Testimi Beta",
    "auth_landing_card1_title": "Kriptografia Post-Kuantum (ML-KEM)",
    "auth_landing_card2_title": "100% e Decentralizuar",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Mbrojtja e Metadënave",
    "auth_landing_card5_title": "ID e Vetë-menaxhuar",
    "auth_landing_hybrid_title": "Kriptografia e sotme plus mbrojtje kundër të nesërmes.",
    "auth_landing_hybrid_desc": "GaiaCom kombinon shkëmbimin e provuar të çelësave klasikë me enkapsulimin e çelësave post-kuantum. Mbrojtje e thellë.",
    "auth_landing_x25519_desc": "Shkëmbim i provuar dhe i shpejtë i çelësave të lakores eliptike për pajisjet aktuale dhe seancat e sigurta.",
    "auth_landing_mlkem_desc": "Enkapsulimi i çelësave post-kuantum për konfidencialitet afatgjatë kundër skenarëve të dekodimit në të ardhmen.",
    "auth_landing_cycle_title": "Serveri nuk sheh asgjë. Rrjeti transporton vetëm zhurmë.",
    "auth_landing_step1_title": "Enkriptimi Lokal",
    "auth_landing_step1_desc": "Mesazhi enkriptohet në pajisjen e dërguesit përpara se të mbërrijë në rrjet ose server.",
    "auth_landing_step2_title": "Transporti si Blob",
    "auth_landing_step2_desc": "Paketa udhëton si zhurmë kriptografike përmes nyjeve të federuara ose shtresave të decentralizuara të ruajtjes.",
    "auth_landing_step3_title": "Ruajtja e Federuar",
    "auth_landing_step3_desc": "Nuk ka kuti postare qendrore si objektiv. Të dhënat janë të fragmentuara, të federuara ose të decentralizuara dhe plotësisht të enkriptuara.",
    "auth_landing_step4_title": "Dekriptimi Lokal",
    "auth_landing_step4_desc": "Vetëm çelësi privat i marrësit mund ta kthejë blobin e enkriptuar përsëri në përmbajtje të lexueshme.",
    "auth_landing_trinity_title": "Një koncept protokolli. Tre nivele të infrastrukturës.",
    "auth_landing_enterprise_desc": "Për korporatat, zyrat ligjore, bizneset e mesme, industrinë dhe bankat private. Rrathë të mbyllur komunikimi me kontroll administrativ dhe mbështetje.",
    "auth_landing_enterprise_list1": "Sovraniteti i brendshëm dhe administrimi i përdoruesve",
    "auth_landing_enterprise_list2": "Nyje e vetë-strehuar ose klaster sovran i menaxhuar",
    "auth_landing_enterprise_list3": "SLA, mbështetje dhe module premium",
    "auth_landing_network_desc": "Rrjeti i hapur për privatësinë dixhitale. Nuk ka tregti të dhënash, por infrastrukturë për komunikim të lirë dhe të enkriptuar.",
    "auth_landing_network_list1": "Aplikacion klient me burim të hapur",
    "auth_landing_network_list2": "Nyje të federuara",
    "auth_landing_network_list3": "Pa çelës qendror dekriptimi",
    "auth_landing_defend_desc": "Infrastrukturë e specializuar e sigurisë së lartë për autoritetet, infrastrukturat kritike dhe silot e izoluara të komunikimit.",
    "auth_landing_defend_list1": "Implantime të izoluara dhe jashtë linje (air-gapped)",
    "auth_landing_defend_list2": "Markë e bardhë (white-label) dhe auditim i kodit burimor",
    "auth_landing_defend_list3": "Sovraniteti dixhitale kombëtar",
    "auth_landing_gov_title": "Protokoll i hapur. Ekzekutim komercial. Ndarje e qartë ligjore.",
    "auth_landing_gov_desc": "GaiaCom ndan protokollin e hapur, klientët e hapur dhe infrastrukturën premium komerciale. Besimi vjen nga transparenca.",
    "auth_landing_price1_desc": "Tarifë e mbrojtjes nga robotët për shpërndarjen në AppStore/PlayStore.",
    "auth_landing_price2_desc": "Burim i hapur falas për përdoruesit që preferojnë ta kompilojnë vetë kodin.",
    "auth_landing_price3_desc": "Për bizneset e mesme, zyrat ligjore dhe ekipet e ndjeshme.",
    "auth_landing_price4_desc": "Për korporatat, klasterët e disponueshmërisë së lartë, LDAP dhe aksesin root të administratorit.",
    "auth_landing_license1_desc": "Transparenca maksimale e kodit për përdoruesit, fork-et dhe auditimet e komunitetit.",
    "auth_landing_license2_desc": "Mbrojtje copyleft për të parandaluar mbylljen komerciale të protokolli.",
    "auth_landing_license3_desc": "LDAP, akses root i administratorit, auditim sigurie, SLA dhe logjikë e specializuar biznesi.",
    "auth_landing_final_title": "Komunikim i bazuar në modelin e zero-besimit.",
    "auth_landing_final_desc": "GaiaCom nuk zëvendëson thjesht emailin. Ai ngre pyetjen se pse komunikimi konfidencial sot ende varet nga kutitë postare qendrore dhe serverët e lexueshëm.",
    "auth_landing_final_note": "Shënim: Kjo faqe përshkruan një vizion arkitekturor dhe udhërrëfyes produkti. Premtimet e sigurisë duhet të konfirmohen nga auditimet përpara përdorimit produktiv."




  };

export default sq;